<template>
  <div class="app align-items-center" id="login-page">
    <div class="logo">
        <div class="image-wrapper">
          <el-image class="mr-134" src="img/Logo_DOffice_2_NoSlogan.png" fit="cover"></el-image>
        </div>
    </div>
   
    <div class="title">
      <div class="text-center">
        <p class="main-title">NỀN TẢNG QUẢN TRỊ</p>
        <p class="main-title">ĐIỀU HÀNH DOANH NGHIỆP</p>
        <p class="sub-title">Chuyển đổi số toàn diện cho doanh nghiệp</p>
      </div>
    </div>
    <div class="login-form">
      <div class="title-div">
        <p class="login-title__main">Đăng nhập</p>
        <p class="login-title__sub">Chào mừng bạn đến với D.OFFICE</p>
      </div>
      <div>
        <el-form
          ref="myForm"
          :model="mData.dataForm"
          :rules="mData.validForm"
          label-width="120px"
          label-position="top"
          @submit.native.prevent
        >
          <b-alert
            style="padding: 10px"
            variant="danger"
            dismissible
            :show="mData.dataDefault.showDismissibleAlert"
            @dismissed="mData.dataDefault.showDismissibleAlert = false"
            >{{ mData.dataDefault.error }}</b-alert
          >
          <el-form-item label="" prop="account">
            <el-input
              prefix-icon="icon-People"
              v-model="mData.dataForm.account"
              size="medium"
              @input="forceUpdateUI"
              placeholder="E-mail or Login"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password" class="password">
            <el-input
              prefix-icon="icon-Lock"
              :type="mData.show === true ? 'text' : 'password'"
              size="medium"
              v-model="mData.dataForm.password"
              @input="forceUpdateUI"
              placeholder="Password"
            >
              <i
                v-if="!mData.show"
                slot="suffix"
                class="el-input__icon isax-eye-slash"
                @click="mData.show = true"
              ></i>
              <i
                v-if="mData.show"
                slot="suffix"
                class="el-input__icon isax-eye"
                @click="mData.show = false"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="remember" class="function">
            <b-row>
              <b-col cols="12" sm="6" class="remember-pass">
                <el-checkbox v-model="mData.dataForm.remember">
                  Nhớ tài khoản
                </el-checkbox>
              </b-col>
              <b-col cols="12" sm="6" class="forgot-pass">
                <b-link link to="/auth/forgotPassword">Quên mật khẩu?</b-link>
              </b-col>
            </b-row>
          </el-form-item>
          <el-form-item class="text-center form-btn" style="margin-bottom: 0">
            <el-button
              :disabled="loading"
              class="button-login"
              native-type="submit"
              @click="fn_submitForm()"
              style="text-transform: uppercase"
              >Đăng nhập</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="people">
      <el-image src="img/people.png" fit="cover"></el-image>
    </div> -->
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import UserApi from '../../moduleApi/UserApi'
import { store } from "../../store/store";
import EventBus from "@/service/EventBus";
import SharedAuthService from "../../service/SharedAuthService";

export default {
  data() {
    return {
      width: window.screen.width,
      height: window.screen.height,
      setT: "",
      aLang: LanguageService.lang,
      aExtension: ExtensionService,
      loading: false,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
        },
        show: false,
        dataForm: {
          account: "",
          password: "",
          remember: true,
        },
        validForm: {
          account: [ValidService.required],
          password: [ValidService.required],
        },
      },
    };
  },
  methods: {
    fn_register() {
      window.location.href = "/dangky";
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          AuthService.login(
            this.mData.dataForm.account.toLowerCase(),
            this.mData.dataForm.password,
            this.mData.dataForm.remember
          )
            .then(async (res) => {
              await UserApi.LogToken({
                env: 'web'
              })
              this.loading = false;
              EventBus.$emit("loadStatus");
              EventBus.$emit("saveFirebaseToken");
              const redirectPath = SharedAuthService.resolveRedirectPath(
                this.$route.query.redirect,
                store.state.redirectLogin ==
                  "Admin-Timekeeping-TimekeepingConfig-AgentConnection"
                  ? "/admin/Timekeeping/TimekeepingConfig/AgentConnection"
                  : SharedAuthService.getDefaultRouter()
              );
              this.$router.push(redirectPath).catch((err) => {})
            })
            .catch((e) => {
              this.loading = false;
              this.mData.dataDefault.showDismissibleAlert = true;
              if (e.code === 37000) {
                if (e.subCode == 1) {
                  this.mData.dataDefault.error = `Tài khoản của bạn tạm thời bị khóa do nhập sai mật khẩu quá nhiều lần!
                  Tài khoản sẽ mở lại sau ${this.calcTimeRemaining(
                    e.meta.lockedTime,
                    e.meta.releaseTime
                  )} phút.`;
                  this.loading = true;
                  setTimeout(() => {
                    this.loading = false;
                  }, 1000 * 900);
                } else {
                  this.mData.dataDefault.error = LanguageService.lang.login_error;
                }
              } else if (e.code == 37001) {
                this.mData.dataDefault.error = `Tài khoản của bạn tạm thời bị khóa do nhập sai mật khẩu quá nhiều lần!
                 Tài khoản sẽ mở lại sau ${this.calcTimeRemaining(
                   e.meta.lockedTime,
                   e.meta.releaseTime
                 )} phút.`;
                this.loading = true;
                setTimeout(() => {
                  this.loading = false;
                }, 1000 * 900);
              } else {
                this.mData.dataDefault.error = "Có vấn đề về đường truyền mạng";
              }
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    calcTimeRemaining(timeLock, timeRelease) {
      let timeL = new Date(timeLock).getTime();
      let timeR = new Date(timeRelease).getTime();
      let timeRemaining = timeR - timeL;
      return new Date(timeRemaining).getMinutes();
    },
  },
  mounted: function () {},
};
</script>

<style scoped>
.alert-dismissible {
  padding-right: 25px !important;
}
::v-deep .alert-dismissible .close {
  padding: 10px;
}
.mr-134 {
  margin-right: 13.4px;
}
.circle {
  display: block;
}
#login-page {
  background-image: url("/img/BG-Login.png");
  background-color: var(--white);
  position: relative;
  z-index: 4000;
  display: block;
  font-family: "Montserrat", sans-serif;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: right;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}
#login-page::after {
  display: none;
}
/* start editing from here */
.logo {
  z-index: 2;
  position: absolute;
  left: 170px;
  width: 480px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo .image-wrapper{
  width: 250px;
  margin: 0 auto;
}
.login-form {
  z-index: 3;
  position: absolute;
  top: 200px;
  left: 159px;
  box-shadow: 0px 0px 30px rgba(0, 3, 32, 0.2);
  background-color: #fff;
  width: 480px;
  min-height: 516px;
  padding: 0;
  border-radius: 10px;
  padding: 50px;
}
.login-form .title-div {
  margin-bottom: 30px;
}
.login-form .title-div .login-title__main {
  text-transform: uppercase;
  margin-bottom: 5px;
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 53px;
  color: var(--orange_text);
  text-shadow: 0px 4px 20px rgba(1, 143, 255, 0.1);
}
.login-form .title-div .login-title__sub {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;
  color: var(--placeholder);
  text-shadow: 0px 4px 20px rgba(1, 143, 255, 0.1);
}
.title {
  z-index: 1;
  position: absolute;
  top: 70px;
  right: 180px;
  width: 660px;
}
.people {
  position: absolute;
  bottom: 5px;
  right: 300px;
  display: block;
}
.title .main-title {
  text-transform: uppercase;
  font-family: RobotoBold;
  font-style: normal;
  font-weight: 700;
  font-size: 50px;
  line-height: 150%;
  background: linear-gradient(90.97deg, #ff586c 0.5%, #ff935c 63.51%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.title .sub-title {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
  color: #585858;
}
.people .el-image {
  width: 520px;
}
.password {
  margin-bottom: 38px !important;
}
.function {
  margin-bottom: 44px !important;
}
.forgot-pass {
  text-align: right;
}
::v-deep .remember-pass .el-checkbox .el-checkbox__label {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #666666;
}
.forgot-pass a {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-decoration-line: underline;
  color: var(--orange_text) !important;
}
::v-deep .el-form-item {
  margin-bottom: 26px;
}
::v-deep .el-input {
  font-size: 16px;
}
::v-deep .el-input__inner {
  height: 58px !important;
  background: #f9fbfc;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding-left: 70px;
  font-size: 16px;
}
::v-deep .el-input__prefix {
  left: 25px;
}
::v-deep .el-input__prefix .el-input__icon {
  font-size: 18px !important;
  color: var(--orange);
}
::v-deep .el-input__suffix .el-input__icon {
  display: block;
  font-weight: 800;
  font-size: 22px !important;
  color: var(--orange);
  margin-top: 4px;
  margin-right: 6px;
}
::v-deep .el-form-item__error {
  font-size: 13px;
  padding-top: 5px;
}
::v-deep ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: var(--placeholder);
}
::v-deep :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: var(--placeholder);
  opacity: 1;
}
::v-deep ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: var(--placeholder);
  opacity: 1;
}
::v-deep :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--placeholder);
}
::v-deep ::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--placeholder);
}

::v-deep ::placeholder {
  /* Most modern browsers support this now. */
  color: var(--placeholder);
}
::v-deep .el-button.button-login {
  width: 275px;
  height: 42px;
  background: linear-gradient(271.88deg, #f07f7e 4.26%, #f9a857 99.01%);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-family: UTM Alter Gothic;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 20px;
  color: var(--white);
}
::v-deep .el-button.button-login:hover {
  background: linear-gradient(271.88deg, #f07f7e 4.26%, #f9a857 99.01%) !important;
}
@media (max-width: 1560px) and (min-width: 1450px) {
  .logo {
    /* top: 50px; */
    /* left: 170px; */

        top: -15px;
        left: 110px;
  }
  .login-form {
    top: 170px;
    left: 100px;
  }
  .title {
    top: 200px;
    right: 110px;
    width: 660px;
  }
  .people .el-image {
    width: 450px;
  }
  .people {
    bottom: 5px;
    right: 240px;
  }
}
@media (max-height: 700px) {
  .login-form {
    top: 140px !important;
    padding: 30px;
    min-height: 485px !important;
  }
}
@media (max-width: 1450px) and (min-width: 1320px) {
  .logo {
    /* top: 50px; */
    /* left: 140px; */
    top: -20px;
    left: 80px;
  }
  .login-form {
    top: 170px;
    left: 70px;
  }
  .title {
    top: 150px;
    right: 60px;
    width: 660px;
  }
  .people .el-image {
    width: 450px;
  }
  .people {
    bottom: 5px;
    right: 170px;
  }

}
@media (max-width: 1319px) and (min-width: 1200px) {
  .logo {
    /* top: 30px;
    left: 115px; */
    top: -20px;
    left: 40px;
  }
  .login-form {
    top: 140px;
    left: 40px;
  }
  .title {
    top: 150px;
    right: 20px;
    width: 660x;
  }
  .people .el-image {
    width: 450px;
  }
  .people {
    bottom: 5px;
    right: 80px;
  }
  .title  .main-title{
    font-size: 45px;
  }
}
@media (max-width: 1199px) and (min-width: 1100px) {
  .logo {
    /* top: 30px;
    left: 120px; */
    top: -20px;
    left: 60px;
  }
  .login-form {
    top: 140px;
    left: 40px;
  }
  .title {
    top: 130px;
    right: 30px;
    width: 550px;
  }
  .title .main-title {
    font-size: 42px;
  }
  .title .sub-title {
    font-size: 17px;
  }
  .people .el-image {
    width: 450px;
  }
  .people {
    bottom: 5px;
    right: 35px;
  }
}
@media (max-width: 1099px) and (min-width: 665px) {
  .logo {
    position: static;
    margin: 0 auto;

  }
  .logo .image-wrapper{
    width: 120px;
    margin: 0 auto;
  }
  .login-form {
    position: static;
    margin: 0 auto;
  }
  .title {
    position: static;
    width: 660px;
    margin: 0 auto;
    text-align: center;
    /* margin-top: 30px; */
    margin-bottom: 35px;
  }
  .title .main-title {
    font-size: 30px;
  }
  .title .sub-title {
    font-size: 13px;
  }
  .people {
    display: none;
  }
}
@media (max-width: 664px) and (min-width: 465px) {
  .logo {
    position: static;
    margin: 0 auto;
    
  }
   .logo .image-wrapper{
    width: 100px;
    margin: 0 auto;
  }
  .login-form {
    position: static;
    margin: 0 auto;
    width: 380px;
    height: 490px;
    padding: 30px;
  }
  .login-form .title-div {
    margin-bottom: 20px;
  }
  .login-form .title-div .login-title__main {
    font-size: 20px;
    line-height: 25px;
  }
  .login-form .title-div .login-title__sub {
    font-size: 16px;
    line-height: 20px;
  }
  .title {
    position: static;
    width: 450px;
    margin: 0 auto;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 30px;
  }
  .title .main-title {
    font-size: 25px;
    line-height: 35px;
  }
  .title .sub-title {
    font-size: 12px;
  }
  .people {
    display: none;
  }
}


@media (max-width: 464px) and (min-width: 300px) {
  #login-page {
    padding: 15px;
    background-position: center;
  }

  .logo {
    position: static;
    margin: 0 auto;
    padding-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .logo .image-wrapper {
    width: 60px;
  }

  .title {
    position: static;
    width: 100%;
    max-width: 300px;
    margin: 15px auto 20px;
    text-align: center;
  }

  .title .main-title {
    font-size: 18px;
    line-height: 1.4;
  }

  .title .sub-title {
    font-size: 9px;
    line-height: 1.3;
  }

  .login-form {
    position: static;
    margin: 0 auto;
    width: 100%;
    max-width: 280px;
    height: auto;
    padding: 25px 20px;
    box-shadow: none;
    border-radius: 8px;
  }

  .login-form .title-div {
    margin-bottom: 20px;
  }

  .login-form .title-div .login-title {
    font-size: 26px;
    line-height: 35px;
  }

  .login-form .title-div .login-title__main {
    font-size: 20px;
    line-height: 25px;
  }

  .login-form .title-div .login-title__sub {
    font-size: 16px;
    line-height: 20px;
  }

  ::v-deep .el-input__prefix {
    left: 15px;
  }

  ::v-deep .el-input__inner {
    padding-left: 45px;
  }

  ::v-deep .el-button.button-login {
    width: 100%;
    height: 42px;
    font-size: 18px;
    color: var(--white);
  }

  ::v-deep .el-button.button-login span {
    text-transform: uppercase !important;
  }

  .people {
    display: none;
  }

  .remember-pass,
  .forgot-pass {
    text-align: center;
    margin-bottom: 10px;
    font-size: 13px;
  }

  .form-btn {
    text-align: center;
  }
}



</style>
